import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuLabel,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { SettingsIcon, UsersIcon } from "lucide-react";
import { PlanBadge } from "./PlanBadge.js";
import { usePlatformSession } from "./PlatformSession.js";

function OrgAvatar({ name }: { name: string }) {
	return (
		<span
			className="grid size-5 shrink-0 place-items-center rounded-md text-[10px] font-semibold uppercase"
			style={{
				background: "var(--mx-accent-soft)",
				color: "var(--mx-accent)",
			}}
			aria-hidden
		>
			{(name.trim()[0] ?? "?").toUpperCase()}
		</span>
	);
}

type Props = {
	onManageMembers: () => void;
	onWorkspaceSettings: () => void;
};

/** Workspace control — name comes from the Mairko tenant, not Clerk orgs. */
export function OrgSwitcher({
	onManageMembers,
	onWorkspaceSettings,
}: Props) {
	const { tenantName } = usePlatformSession();
	const label = tenantName?.trim() || "Workspace";

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<button
					type="button"
					className="org-switcher-trigger"
					aria-label={`Workspace: ${label}`}
				>
					<OrgAvatar name={label} />
					<span className="org-switcher-name">
						{label}
						<PlanBadge />
					</span>
				</button>
			</DropdownMenuTrigger>
			<DropdownMenuContent
				align="start"
				side="bottom"
				sideOffset={4}
				className="org-switcher-menu w-[var(--radix-dropdown-menu-trigger-width)] min-w-[220px]"
			>
				<DropdownMenuLabel>Workspace</DropdownMenuLabel>
				<DropdownMenuItem onSelect={onWorkspaceSettings}>
					<SettingsIcon className="size-3.5" aria-hidden />
					Settings
				</DropdownMenuItem>
				<DropdownMenuSeparator />
				<DropdownMenuItem onSelect={onManageMembers}>
					<UsersIcon className="size-3.5" aria-hidden />
					Members
				</DropdownMenuItem>
			</DropdownMenuContent>
		</DropdownMenu>
	);
}
